var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "row-style": _vm.rowStyleFun,
          "col-span": _vm.colSpan,
          "label-width": "100px",
          "search-btn-span": _vm.colSpan,
          "default-sort": _vm.defaultSort,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          "before-reset-search": _vm.beforeResetSearch,
          "tooltip-config": { contentMethod: false, enterable: true },
          selection: _vm.selection,
        },
        on: {
          "sort-change": _vm.sortChange,
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
          afterFetchOriginalData: _vm.afterFetchOriginalData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "baseForm",
              fn: function () {
                return [
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("billingPage.CustomerName"),
                            prop: "cusId",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.customerList,
                              placeholder: _vm.$t("customerNameText"),
                            },
                            model: {
                              value: _vm.queryParams.cusId,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "cusId", $$v)
                              },
                              expression: "queryParams.cusId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "AccountManagement.customer.companyName"
                            ),
                            prop: "companyName",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t(
                                "AccountManagement.customer.companyName"
                              ),
                              comma: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleQuery.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.queryParams.companyName,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "companyName", $$v)
                              },
                              expression: "queryParams.companyName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("workOrderList.Number"),
                            prop: "workNo",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t("workOrderList.Number"),
                              comma: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleQuery.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.queryParams.workNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "workNo", $$v)
                              },
                              expression: "queryParams.workNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("WorkorderType.table.InquiryType"),
                            prop: "consultNameList",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.consultNameList,
                              multiple: "",
                              placeholder: _vm.$t(
                                "WorkorderType.table.InquiryType"
                              ),
                            },
                            model: {
                              value: _vm.queryParams.consultNameList,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams,
                                  "consultNameList",
                                  $$v
                                )
                              },
                              expression: "queryParams.consultNameList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("workOrderList.Customer"),
                            prop: "customer",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.customerNameList,
                              placeholder: _vm.$t("workOrderList.Customer"),
                            },
                            model: {
                              value: _vm.queryParams.customer,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "customer", $$v)
                              },
                              expression: "queryParams.customer",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.Operator"),
                            prop: "userId",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.userIdNameList,
                              placeholder: _vm.$t("workOrderList.Operator"),
                            },
                            model: {
                              value: _vm.queryParams.userId,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "userId", $$v)
                              },
                              expression: "queryParams.userId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("table.createTimeText") } },
                        [
                          _c("BjDateRangePicker", {
                            attrs: {
                              placeholder: _vm.$t("table.createTimeText"),
                            },
                            model: {
                              value: _vm.queryParams_createTime,
                              callback: function ($$v) {
                                _vm.queryParams_createTime = $$v
                              },
                              expression: "queryParams_createTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("workOrderList.Completion") },
                        },
                        [
                          _c("BjDateRangePicker", {
                            attrs: {
                              placeholder: _vm.$t("workOrderList.Completion"),
                            },
                            model: {
                              value: _vm.queryParams_endTime,
                              callback: function ($$v) {
                                _vm.queryParams_endTime = $$v
                              },
                              expression: "queryParams_endTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            !_vm.closeType
              ? {
                  key: "beforeSearchBtn",
                  fn: function () {
                    return [
                      _c(
                        "el-col",
                        { attrs: { span: 24 - _vm.colSpan } },
                        [
                          _c(
                            "el-tabs",
                            {
                              attrs: { value: _vm.tabIndex, type: "card" },
                              on: { "tab-click": _vm.handleTabClick },
                            },
                            _vm._l(
                              _vm.CSG_WORK_ORDER_LIST_ADMIN_OPEN,
                              function (item, index) {
                                return _c("el-tab-pane", {
                                  key: index,
                                  attrs: {
                                    label: _vm.$t(item.label),
                                    name: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : {
                  key: "beforeSearchBtn",
                  fn: function () {
                    return [
                      _c(
                        "el-col",
                        { attrs: { span: 24 - _vm.colSpan } },
                        [
                          _c(
                            "el-tabs",
                            {
                              attrs: { value: _vm.tabIndex, type: "card" },
                              on: { "tab-click": _vm.handleTabClick },
                            },
                            _vm._l(
                              _vm.CSG_WORK_ORDER_LIST_ADMIN_CLOSE,
                              function (item, index) {
                                return _c("el-tab-pane", {
                                  key: index,
                                  attrs: {
                                    label: _vm.$t(item.label),
                                    name: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
            {
              key: "tableOperation",
              fn: function () {
                return [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onAdd },
                        },
                        [_vm._v(_vm._s(_vm.$t("addText")))]
                      ),
                      _c("BjFrontendExport", {
                        attrs: {
                          type: "primary",
                          "label-list": _vm.exportLabelList,
                          rows: _vm.selectedRows,
                          "file-name": "workOrders.csv",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "tableColumn",
              fn: function () {
                return [
                  _vm._l(_vm.dropCols, function (col, index) {
                    return [
                      col.prop !== "bjTableAction"
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || false,
                              align: "center",
                              "class-name": "item",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      false
                                        ? void 0
                                        : col.prop == "cusId"
                                        ? [
                                            _vm._v(
                                              _vm._s(
                                                _vm.customerList.bjGet(
                                                  scope.row.cusId
                                                )
                                              )
                                            ),
                                          ]
                                        : col.prop === "outerOrderNo"
                                        ? [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(scope.row.webReference)
                                              ),
                                            ]),
                                            _c("BjCopyIcon", {
                                              attrs: {
                                                copy: scope.row.webReference,
                                              },
                                            }),
                                          ]
                                        : col.prop === "exigency"
                                        ? [
                                            scope.row.exigency
                                              ? _c("el-tag", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row[col.prop]
                                                        ? _vm.$t(
                                                            _vm.CSG_WORK_ORDER_EXIGENCY.bjGet(
                                                              scope.row[
                                                                col.prop
                                                              ]
                                                            )
                                                          )
                                                        : ""
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        : col.prop === "status"
                                        ? [
                                            _c("el-tag", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.CSG_WORK_ORDER_STATUS_ADMIN.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        : col.prop === "pause"
                                        ? [
                                            scope.row.pause
                                              ? _c("el-tag", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row[col.prop]
                                                        ? _vm.$t(
                                                            _vm.CSG_WORK_ORDER_PAUSE.bjGet(
                                                              scope.row[
                                                                col.prop
                                                              ]
                                                            )
                                                          )
                                                        : ""
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeFilters")(
                                                  scope.row[col.prop],
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                      col.prop === "bjTableAction"
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || "right",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (props) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onView(props.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("viewText")))]
                                      ),
                                      _c(
                                        "el-dropdown",
                                        {
                                          directives: [
                                            {
                                              name: "hasDropdownChildren",
                                              rawName: "v-hasDropdownChildren",
                                            },
                                          ],
                                          attrs: {
                                            disabled: props.row.status == 7,
                                          },
                                          on: {
                                            command: function ($event) {
                                              return _vm.command(
                                                $event,
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "el-dropdown-link" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "AccountManagement.common.operate"
                                                  )
                                                )
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-arrow-down el-icon--right",
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown",
                                            },
                                            [
                                              [1, 2, 6].includes(
                                                props.row.status
                                              )
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "edit",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("editText")
                                                        ) + " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              [1].includes(props.row.status)
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "delete",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t("delText")
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              [1, 6].includes(props.row.status)
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "submit",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "workOrderList.WOSubmit"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              props.row.status == 2 &&
                                              _vm.$store.getters.userInfo.deptAbbr.includes(
                                                props.row.operationDepartment
                                              )
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "permission",
                                                          rawName:
                                                            "v-permission:BusinessWorkOrderAudit",
                                                          arg: "BusinessWorkOrderAudit",
                                                        },
                                                      ],
                                                      attrs: {
                                                        command: "approval",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "workOrderList.Approval"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              (props.row.status == 3 ||
                                                (props.row.status == 4 &&
                                                  props.row.pause == 1)) &&
                                              _vm.$store.getters.userInfo.id ==
                                                props.row.userId
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "start",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "workOrderList.Start"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              props.row.status == 4 &&
                                              props.row.pause == 0 &&
                                              _vm.$store.getters.userInfo.id ==
                                                props.row.userId
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "stop",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "workOrderList.Pause"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              props.row.status == 4 &&
                                              props.row.pause == 0 &&
                                              _vm.$store.getters.userInfo.id ==
                                                props.row.userId
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "completed",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "workOrderList.Complete"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              [5, 9].includes(props.row.status)
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "permission",
                                                          rawName:
                                                            "v-permission:BusinessWorkOrderConfirmCharges",
                                                          arg: "BusinessWorkOrderConfirmCharges",
                                                        },
                                                      ],
                                                      attrs: {
                                                        command: "hoursDone",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "workOrderList.Confirm"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              props.row.status == 3 &&
                                              _vm.$store.getters.userInfo.deptAbbr.includes(
                                                props.row.operationDepartment
                                              )
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "permission",
                                                          rawName:
                                                            "v-permission:BusinessWorkOrderAudit",
                                                          arg: "BusinessWorkOrderAudit",
                                                        },
                                                      ],
                                                      attrs: {
                                                        command: "processor",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "workOrderList.processor"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              [2, 3, 6].includes(
                                                props.row.status
                                              )
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "invalid",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "workOrderList.to"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              [3, 4].includes(props.row.status)
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      attrs: {
                                                        command: "endTimeEdit",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "workOrderList.editTime"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  directives: [
                                                    {
                                                      name: "permission",
                                                      rawName:
                                                        "v-permission:BusinessWorkOrderModify",
                                                      arg: "BusinessWorkOrderModify",
                                                    },
                                                  ],
                                                  attrs: {
                                                    command: "customerEdit",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "workOrderList.Modify"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("workOrderList.processor"),
            visible: _vm.addDialogVisible,
            width: "500px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("workOrderList.Operator"),
                    prop: "userId",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.userRoleList,
                      placeholder: _vm.$t("workOrderList.Operator"),
                    },
                    on: { change: _vm.logSome },
                    model: {
                      value: _vm.form.userId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "userId", $$v)
                      },
                      expression: "form.userId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleClose("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("workOrderList.Modify"),
            visible: _vm.addDialogVisibl2,
            width: "500px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisibl2 = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form2",
              attrs: {
                model: _vm.form2,
                rules: _vm.rules2,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("workOrderList.Customer"),
                    prop: "customer",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.customerNameList,
                      placeholder: _vm.$t("workOrderList.Customer"),
                    },
                    model: {
                      value: _vm.form2.customer,
                      callback: function ($$v) {
                        _vm.$set(_vm.form2, "customer", $$v)
                      },
                      expression: "form2.customer",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleClose("form2")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.editWorkerCustomer("form2")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("workOrderList.editTime"),
            visible: _vm.addDialogVisibl3,
            width: "500px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisibl3 = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form3",
              attrs: {
                model: _vm.form3,
                rules: _vm.rules3,
                "label-width": "165px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("workOrderList.editTime"),
                    prop: "auditTime",
                  },
                },
                [
                  _c("BjDateRangePicker", {
                    attrs: {
                      "picker-options": _vm.pickerOptions,
                      placeholder: _vm.$t("workOrderList.editTime"),
                    },
                    model: {
                      value: _vm.form3_endTime,
                      callback: function ($$v) {
                        _vm.form3_endTime = $$v
                      },
                      expression: "form3_endTime",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleClose("form3")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.editWorkerEndTime("form3")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }